// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1CkgF","rootSmall":"AddTileButton_rootSmall__3wHPr"};